var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "app-footer no-print" }, [
    _c("div", { staticClass: "footer-wrap" }, [
      _c(
        "div",
        { staticClass: "footer-logo" },
        [
          _c(
            "a",
            {
              attrs: {
                href: "https://asokoinsight.com",
                "aria-label": "Asoko Insight Logo",
              },
            },
            [_c("asoko-logo-transparent")],
            1
          ),
          _vm._v(" "),
          _c("app-copyright"),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer-content" }, [
        _c("div", { staticClass: "footer-blocks" }, [
          _c(
            "div",
            { staticClass: "footer-block first-block" },
            [
              _c("h6", [_vm._v("About Us")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            Asoko Insight is Africa's leading corporate data and engagement platform, providing global investors, multinationals and development institutions the most effective route to discover, shortlist and engage their target universe of African companies.\n          "
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "link-details", attrs: { to: "/about/team" } },
                [_vm._v("\n            Read More\n          ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "inner-block" },
                [
                  _c("h6", [_vm._v("Press")]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "link-details",
                      attrs: { to: "/insights/developments" },
                    },
                    [_vm._v("\n              Corporate news\n            ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer-block narrow-block" }, [
            _c("h6", [_vm._v("Our Offices")]),
            _vm._v(" "),
            _c("p", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://goo.gl/maps/A4k7JqNW2ETWo7449",
                    target: "_blank",
                    rel: "noopener",
                  },
                  on: { click: _vm.trackOurOfficesClick },
                },
                [_vm._v("London, UK")]
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://goo.gl/maps/wdyNfbCvwYUUL64D9",
                    target: "_blank",
                    rel: "noopener",
                  },
                  on: { click: _vm.trackOurOfficesClick },
                },
                [_vm._v("Nairobi, Kenya")]
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer-block" }, [
            _c("h6", [_vm._v("Contacts")]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-item" }, [
              _c("p", [_vm._v("General Enquiries")]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: { href: "mailto:info@asokoinsight.com" },
                    on: { click: _vm.trackContactsClick },
                  },
                  [_vm._v("info@asokoinsight.com")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-item" }, [
              _c("p", [_vm._v("News Enquiries")]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: { href: "mailto:editorial@asokoinsight.com" },
                    on: { click: _vm.trackContactsClick },
                  },
                  [_vm._v("editorial@asokoinsight.com")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-item" }, [
              _c("p", [_vm._v("Custom Sales Enquiries")]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: { href: "mailto:sales@asokoinsight.com" },
                    on: { click: _vm.trackContactsClick },
                  },
                  [_vm._v("sales@asokoinsight.com")]
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "footer-blocks" }, [
          _c(
            "div",
            { staticClass: "footer-block first-block" },
            [
              _c("h6", [_vm._v("Careers")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            Asoko is growing fast and has exciting apportunities in multiple\n            locations.\n          "
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "link-details",
                  attrs: { to: "/about/careers" },
                },
                [_vm._v("See Current Openings")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer-block split-block" }, [
            _c(
              "div",
              { staticClass: "split-child social-block narrow-block" },
              [
                _c("h6", [_vm._v("Follow Us")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://www.facebook.com/asokoinsight",
                      "aria-label": "Asoko Insight Facebook",
                      rel: "noopener",
                    },
                  },
                  [_c("facebook-icon")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://twitter.com/AsokoInsight",
                      "aria-label": "Asoko Insight Twitter",
                      rel: "noopener",
                    },
                  },
                  [_c("twitter-icon")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://www.linkedin.com/company/asoko-insight",
                      "aria-label": "Asoko Insight Linkedin",
                      rel: "noopener",
                    },
                  },
                  [_c("linkedin-icon")],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "split-child newsletter-block" }, [
              _c("h6", [_vm._v("Get our latest news")]),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "subscribe-form",
                  attrs: {
                    action:
                      "//asokoinsight.us8.list-manage.com/subscribe/post?u=000851abb8cd26332f7f52c27&id=7d19169446",
                    method: "post",
                    id: "mc-embedded-subscribe-form-footer",
                    name: "mc-embedded-subscribe-form",
                    target: "_blank",
                  },
                },
                [
                  _c("input", {
                    staticClass: "subscribe-input",
                    attrs: {
                      type: "email",
                      value: "",
                      name: "EMAIL",
                      "aria-label": "Email",
                      id: "mce-EMAIL",
                      placeholder: "Email",
                      required: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "subscribe-input",
                    attrs: {
                      type: "text",
                      value: "",
                      name: "MMERGE5",
                      "aria-label": "Organization",
                      id: "mce-ORGANIZATION",
                      placeholder: "Organization",
                      required: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "b_000851abb8cd26332f7f52c27_7d19169446",
                      tabindex: "-1",
                      value: "",
                      autocomplete: "off",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        type: "submit",
                        name: "subscribe",
                        id: "mc-embedded-subscribe",
                      },
                      on: { click: _vm.subscribe },
                    },
                    [_vm._v("\n                Go\n              ")]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("img", {
      staticStyle: { display: "none" },
      attrs: {
        height: "1",
        width: "1",
        alt: "",
        src: "https://px.ads.linkedin.com/collect/?pid=2807145&fmt=gif",
      },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "remote-locations" }, [
      _c("p", { staticClass: "locations-subheader" }, [
        _vm._v(
          "Asoko research staff operate through remote offices across the following African cities:"
        ),
      ]),
      _c("p"),
      _c("p", [_vm._v("Abidjan, Cote d'Ivoire")]),
      _vm._v(" "),
      _c("p", [_vm._v("Accra, Ghana")]),
      _vm._v(" "),
      _c("p", [_vm._v("Addis Ababa, Ethiopia")]),
      _vm._v(" "),
      _c("p", [_vm._v("Cairo, Egypt")]),
      _vm._v(" "),
      _c("p", [_vm._v("Dar es Salaam, Tanzania")]),
      _vm._v(" "),
      _c("p", [_vm._v("Kampala, Uganda")]),
      _vm._v(" "),
      _c("p", [_vm._v("Lagos, Nigeria")]),
      _vm._v(" "),
      _c("p", [_vm._v("Kigali, Rwanda")]),
      _vm._v(" "),
      _c("p", [_vm._v("Yaounde, Cameroon")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }